import { render, staticRenderFns } from "./productOrderDetail.vue?vue&type=template&id=76aee058&scoped=true"
import script from "./productOrderDetail.vue?vue&type=script&lang=js"
export * from "./productOrderDetail.vue?vue&type=script&lang=js"
import style0 from "./productOrderDetail.vue?vue&type=style&index=0&id=76aee058&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76aee058",
  null
  
)

export default component.exports